module.exports = __webpack_public_path__ + "static/media/questionnaire.9343344b.svg";